"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxableFees = exports.CompoundTaxTerritory = exports.TaxType = exports.RateType = exports.ConsumerType = exports.CannabisType = void 0;
// Base Product and Cannabis Type Enums
var CannabisType;
(function (CannabisType) {
    CannabisType["NONE"] = "None";
    CannabisType["DEFAULT"] = "Default";
    CannabisType["NON_CANNABIS"] = "Non-cannabis";
    CannabisType["CBD"] = "CBD";
    CannabisType["CBD_CANNABIS"] = "CBD Cannabis";
    CannabisType["CBD_CANNABIS_FLOWER"] = "CBD Cannabis Flower";
    CannabisType["CONCENTRATE"] = "Concentrate";
    CannabisType["NON_CONCENTRATE"] = "Non-concentrate";
    CannabisType["PLANT"] = "Plant";
    CannabisType["EDIBLE"] = "Edible";
    CannabisType["EXTRACT"] = "Extract";
    CannabisType["DRY_FLOWER"] = "Dried Flower";
    CannabisType["KIEF"] = "Kief";
    CannabisType["DRY_LEAF"] = "Dried Leaf";
    CannabisType["LIQUID"] = "Liquid";
    CannabisType["SUPPOSITORY"] = "Suppository";
    CannabisType["TINCTURE"] = "Tincture";
    CannabisType["TOPICAL"] = "Topical";
    CannabisType["OIL"] = "Oil";
    CannabisType["SEEDS"] = "Seeds";
    CannabisType["THC"] = "THC";
    CannabisType["LIVE_PLANT"] = "Live Plants";
    CannabisType["IMMATURE_PLANT"] = "Immature Plants";
    CannabisType["CLONE_CUTTING"] = "Clone Cutting";
    CannabisType["CLONE_TISSUE_CULTURE"] = "Clone Tissue Culture";
    CannabisType["PRE_ROLL_FLOWER"] = "Pre Roll Flower";
    CannabisType["PRE_ROLL_LEAF"] = "Pre Roll Leaf";
    CannabisType["PRE_ROLL_INFUSED"] = "Pre Roll Infused";
    CannabisType["SEEDS_EA"] = "Seeds Each";
    CannabisType["PRE_ROLL"] = "Preroll";
    CannabisType["PRE_ROLL_CBD"] = "CBD Preroll";
    CannabisType["CAPSULE"] = "Capsule";
    CannabisType["COMBINED"] = "Combined Category";
    CannabisType["LOZENGES"] = "Lozenges";
    CannabisType["EXTRACT_INHALED"] = "Extracts Inhaled";
    CannabisType["BEVERAGES"] = "Beverages";
    CannabisType["GEL_BASED_FOOD"] = "Gel-based foods";
    CannabisType["ORAL_LIQUID"] = "Oral Liquids";
    CannabisType["RESIN"] = "Resin";
    CannabisType["SOLID_CHOCOLATE"] = "Solid Chocolates";
    CannabisType["WATER_SOLUBLE_EDIBLE"] = "Water Soluble Edibles";
    CannabisType["WAX"] = "Wax or shatter";
    CannabisType["CANNABIS_FLOWER_PRODUCT"] = "Cannabis Flower Products";
    CannabisType["OIL_FOR_VAPORIZATION"] = "Oil for Vaporization";
    CannabisType["TABLE_CAPSULE_LOZENGE"] = "Tablets/Capsules/Lozenges";
    CannabisType["CANNABINOID_PROD_FOR_INHALATION"] = "Cannabinoid products for inhalation";
})(CannabisType || (exports.CannabisType = CannabisType = {}));
var ConsumerType;
(function (ConsumerType) {
    ConsumerType["OTHER"] = "Other";
    ConsumerType["ADULT_USE"] = "AdultUse";
    ConsumerType["MEDICINAL_STATE"] = "MedicinalState";
    ConsumerType["MEDICINAL_THIRD_PARTY"] = "MedicinalThirdParty";
})(ConsumerType || (exports.ConsumerType = ConsumerType = {}));
var RateType;
(function (RateType) {
    RateType["POTENCY"] = "potency";
    RateType["FLAT"] = "flat";
    RateType["PERCENTAGE"] = "percentage";
})(RateType || (exports.RateType = RateType = {}));
/**
 * Tax Type enum matching Java's TaxRateMappingUtil.TaxType
 */
var TaxType;
(function (TaxType) {
    TaxType["CITY"] = "City";
    TaxType["COUNTY"] = "County";
    TaxType["STATE"] = "State";
    TaxType["FEDERAL"] = "Federal";
    TaxType["EXCISE"] = "Excise";
    TaxType["MUNICIPAL"] = "Municipal";
})(TaxType || (exports.TaxType = TaxType = {}));
/**
 * Compound Tax Territory enum for mapping
 */
var CompoundTaxTerritory;
(function (CompoundTaxTerritory) {
    CompoundTaxTerritory["CITY"] = "City";
    CompoundTaxTerritory["COUNTY"] = "County";
    CompoundTaxTerritory["STATE"] = "State";
    CompoundTaxTerritory["FEDERAL"] = "Federal";
})(CompoundTaxTerritory || (exports.CompoundTaxTerritory = CompoundTaxTerritory = {}));
// All system fee products (cf. SystemFeesProductNames enum in product package) + bottle deposit fee
var TaxableFees;
(function (TaxableFees) {
    TaxableFees["SHIPPING"] = "shipping";
    TaxableFees["TIP"] = "tip";
    TaxableFees["SURCHARGE"] = "surcharge";
    TaxableFees["DEPOSIT_FEE"] = "depositFee";
})(TaxableFees || (exports.TaxableFees = TaxableFees = {}));
//# sourceMappingURL=tax-models.js.map